module.exports = __webpack_public_path__ + "img/icon-chu-ky.4b0e5fdb.png";